/*
  LUCÍA DE MIGUEL PDP — álbum de galería por color.

  Ver docs/vrs-media-color-groups.md para la convención completa.

  Principio de seguridad: este script NUNCA inventa una relación.
  Si el producto no tiene NINGÚN media marcado con [vrs-color:slug] o
  [vrs-shared] en su alt, el script no hace nada — la galería se
  comporta exactamente igual que sin este archivo (el hide_variants
  nativo de Horizon sigue siendo el único mecanismo activo).

  Escucha el evento 'change' real de los inputs de color del
  selector de variantes nativo — reacciona igual venga el cambio del
  Lucía de Miguel Mobile Purchase Dock, de un selector de escritorio o de
  cualquier otro mecanismo nativo que dispare ese mismo input.
*/
(() => {
  const variantPicker = document.querySelector('.variant-picker');
  if (!variantPicker) return;

  const colorInputs = [...variantPicker.querySelectorAll('input[data-option-name]')].filter((el) =>
    /color|colour/i.test(el.dataset.optionName || '')
  );
  if (!colorInputs.length) return;

  // Todo elemento de galería que PUEDE llevar un grupo (slides del
  // slideshow móvil + <li> del grid de escritorio).
  const taggable = [...document.querySelectorAll('slideshow-slide, .media-gallery__grid li')];
  const hasAnyGroup = taggable.some((el) => el.dataset.vrsColorGroup || el.dataset.vrsShared === 'true');

  // Sin ningún marcador en el catálogo: no tocar nada.
  if (!hasAnyGroup) return;

  const slugify = (value) => (value || '').toLowerCase().trim();

  const applyFilter = (activeSlug) => {
    const matching = taggable.filter((el) => {
      const group = (el.dataset.vrsColorGroup || '')
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean);
      return group.includes(activeSlug);
    });

    // Salvaguarda: si el color activo no tiene NINGÚN media propio
    // marcado todavía, no ocultamos nada (evita una galería vacía
    // por un mapping incompleto — ver docs/vrs-media-color-groups.md).
    if (matching.length === 0) {
      taggable.forEach((el) => {
        el.hidden = false;
      });
      return;
    }

    taggable.forEach((el) => {
      const group = (el.dataset.vrsColorGroup || '')
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean);
      const shared = el.dataset.vrsShared === 'true';
      const belongsToActive = group.includes(activeSlug);
      el.hidden = !(shared || belongsToActive);
    });
  };

  const syncFromSelectedInput = () => {
    const checked = colorInputs.find((el) => el.checked);
    if (!checked) return;
    const slug = slugify(checked.getAttribute('aria-label') || checked.value);
    applyFilter(slug);
  };

  colorInputs.forEach((input) => {
    input.addEventListener('change', syncFromSelectedInput);
  });

  // Estado inicial (variante ya preseleccionada al cargar la página).
  syncFromSelectedInput();
})();
